const CONVERSATION_CHARGE = {
  PAGE_TITLE: 'خرید شارژ مکالمه | رایچت',

  HEADING_TITLE: 'خريد شارژ مكالمه',
  HEADING_SUBTITLE:
    'شما می‌توانید با انتخاب تعداد شارژ مورد نیاز خود و ادامه فرآیند پرداخت، تعداد مکالمات خود را شارژ نمایید.',

  CONVERSATIN_COUNT: 'تعداد مكالمه',
  PRICE_PER_CONV: 'قيمت هر مكالمه برای پكيج شما #price# تومان می باشد',
  CONV_CHARGE: 'شارژ مكالمه',
  TAX: 'ماليات',
  POSTING: 'ارسال پستی',
  TOTAL: 'جمع كل',
  SEND_OFFICIAL_INVOICE: 'ارسال پستی فاکتور',
  CONTINUE_PURCHASE: 'ادامه فرآیند خرید',
  REDIRECT_TO_PAYMENT_GATEWAY: 'بررسی و انتقال به درگاه پرداخت',
  UNIT: 'تومان',
  INFO_EDIT_BTN: 'ویرایش',
};

export default CONVERSATION_CHARGE;
